<sf-staff-search [initialFilter]="filter()" (searched)="filterChanged($event)"></sf-staff-search>

<sf-card>
    @if (staff(); as staffPaged) {
        <sf-staff-table [staff]="staffPaged.items" (onUnlockAccount)="unlockStaffAccount($event)"></sf-staff-table>
        @if (staffPaged.totalItemCount > 0) {
            <ngb-pagination
                class="d-flex justify-content-end"
                [(page)]="staffPaged.pageNumber"
                [pageSize]="staffPaged.pageSize"
                [collectionSize]="staffPaged.totalItemCount"
                [maxSize]="4"
                [rotate]="true"
                size="sm"
                (pageChange)="pageChanged($event)"></ngb-pagination>
        }
    }
</sf-card>

<sf-page-action-bar>
    <a sfButton color="primary" icon="map-location" routerLink="/staff-tracker">Staff Tracking</a>
    <a sfButton color="secondary" icon="plus" routerLink="/staff/0/details">Add Staff</a>
</sf-page-action-bar>
